export default {
  PUBLISH: 'publish',
  PREVIEW: 'preview',
};
